export const INVITE_ERROR_QUERY_PARAM = "inviteErrorCode";
